<div class="At-Wrapper">
    <section class="At-SectionLogin">
        <div class="container-fluid p-0">
            <div class="row no-gutters">
                <div class="col-md-5 at_Mainlogin At-CustomCol-47 d-flex align-items-center justify-content-center">
                    <div class="At-LoginFormGeneral">
                        <div class="At-ImgHolder At-ImgHolderLoginLogo">
                            <i class="icon-logo"></i>
                        </div>
                        <h2>Create Account</h2>
                        <h5>Get Access to Loads of Features</h5>
                        <form class=" ">
                            <div class="form-group At-UploadBtnHolder at_settingimg border-bottom-0">
                                <label for="addimg">
                                    <div class="At-LabelInner">
                                        <i class="icon-gallery"></i>
                                    </div>
                                    <p>UPLOAD PHOTO</p>
                                </label>
                                <input type="file" class="form-control-file" id="addimg">
                            </div>
                            <div class="form-group ">
                                <div class="At-Input">
                                    <input id="fullName" class="form-control " placeholder="Full Name">
                                </div>
                            </div>
                            <div class="form-group ">
                                <div class="At-Input">
                                    <input id="nickName" class="form-control " placeholder="Nickname">
                                </div>
                            </div>
                            <div class="form-group ">
                                <div class="At-Input">
                                    <input id="email" class="form-control " placeholder="Email">
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="At-InputIcon">
                                    <i class="icon-eye"></i>
                                    <input type="password" class="form-control" id="Password"
                                        aria-describedby="emailHelp" placeholder="Password">
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="At-InputIcon">
                                    <i class="icon-eye"></i>
                                    <input type="password" class="form-control" id="ConfirmPassword"
                                        aria-describedby="emailHelp" placeholder="Confirm Password">
                                </div>
                            </div>

                            <div class="form-group">
                                <button class="At-Btn At-BtnSignup">SIGN UP </button>
                            </div>

                        </form>
                        <div class="At-DntHaveAccount">
                            <h6>Already have an account? <a routerLink="/login">SIGN IN</a></h6>
                        </div>
                    </div>
                </div>
                <!-- at_Mainlogin ends -->

                <div class="col-md-7 At-BannerLogin At-CustomCol-53 d-flex align-items-center justify-content-center">
                    <div class="At-ImgHolder ">
                        <figure>
                            <img src="assets/images/signup-right-bg.png" class="img-fluid" alt="">
                        </figure>
                    </div>
                    <a class="At-GetMobileAppLink" href="#">GET YOUR MOBILE APP >></a>
                </div>
                <!-- At-BannerLogin ends -->
            </div>
        </div>
    </section>
</div>